// extracted by mini-css-extract-plugin
module.exports = {"btnWrapper":"_3WY3UfLSmQLEeMNVuqbM10","cancelBtn":"_1yLl8ecPFRBBUMVoGH5i13","saveBtn":"l4fwyx6OOGeaJISKXDSlS"};